import React from "react";
import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { ConfirmationBoxWrapper } from "./ConfirmationBoxStyled";
const ConfirmationBox = ({
    show,
    title,
    heading,
    handleConfirmClick,
    handleCancelClick,
}) => {
    return (
        <div>
            <ConfirmationBoxWrapper
                open={show}
                onClose={handleCancelClick}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                scroll="paper"
                maxWidth="xs"
                fullWidth={true}
            >
                <DialogTitle id="alert-dialog-title" className="customDialogTitle">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="alert-dialog-description"
                        className="customDialog"
                    >
                        <div>{heading}</div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialogbutton">
                    <>
                        <Button
                            variant="outlined"
                            className="rightButton"
                            onClick={handleCancelClick}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            className="confirmButton"
                            onClick={handleConfirmClick}
                        >
                            OK
                        </Button>
                    </>
                </DialogActions>
            </ConfirmationBoxWrapper>
        </div>
    );
};

export default ConfirmationBox;
